import CaseFolders from "../CaseFolders";
import Notifications from "../Notifications";
import Overview from "../Overview";
import PaymentHistory from "../PaymentHistory";
import Requests from "../Requests";
import Settings from "../Settings";
import CreateCase from "../internals/case-folder/CreateCase";
import FileAsDefendant from "../internals/case-folder/FileAsDefendant";
import FileAsThirdParty from "../internals/case-folder/FileAsThirdParty";
import FileDefenceProcess from "../internals/case-folder/FileDefenceProcess";
import FileNewProcess from "../internals/case-folder/FileNewProcess";
import SearchResult from "../internals/case-folder/SearchResult";
import ViewCaseFolder from "../internals/case-folder/ViewCaseFolder";
import Teams from "../Teams";

export const PoliceRoute = [
  {
    title: "Overview",
    path: "/police/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/police/case-folders",
    component: CaseFolders,
  },
  {
    title: "Create Case",
    path: "/police/case-folders/create",
    component: CreateCase,
  },
  {
    title: "View Case Folder",
    path: "/police/case-folders/view",
    component: ViewCaseFolder,
  },
  {
    title: "Create Case",
    path: "/police/case-folders/create",
    component: CreateCase,
  },
  {
    title: "Create Case",
    path: "/police/case-folders/view/file-new-process",
    component: FileNewProcess,
  },
  {
    title: "File Defence Process",
    path: "/police/case-folders/view/file-defence-process",
    component: FileDefenceProcess,
  },
  {
    title: "File Defence Process",
    path: "/police/case-folders/file-defendant-process",
    component: FileAsDefendant,
  },
  {
    title: "File Defence Process",
    path: "/police/case-folders/file-third-party-process",
    component: FileAsThirdParty,
  },
  {
    title: "Create Case",
    path: "/police/case-folders/search-result",
    component: SearchResult,
  },
  {
    title: "Joinder request",
    path: "/police/request",
    component: Requests,
  },
  {
    title: "Teams",
    path: "/police/teams",
    component: Teams,
  },
  {
    title: "Payment history",
    path: "/police/payment-history",
    component: PaymentHistory,
  },
  {
    title: "Notification",
    path: "/police/notification",
    component: Notifications,
  },
  {
    title: "Setting",
    path: "/police/setting",
    component: Settings,
  },
];
